import { Component, OnInit , EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule, FormArray  } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../../../services/common-data.service';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-product-settings-details',
  templateUrl: './product-settings-details.component.html',
  styleUrls: ['./product-settings-details.component.scss']
})
export class ProductSettingsDetailsComponent implements OnInit {

  modelForm: FormGroup;
  pageName = "Add New Product";
  modelName = "Product";

  @Input() dataModel;
  @Input() dataModelId;
  @Output() formSubmitted = new EventEmitter<any>();


  localModelDataStorage = false;
  modelId = '0';
  modelData: any;
  returnData: any;
  files: any;

  filesToUpload: Array<File> = [];
  sizes: FormArray;

  constructor(
    //private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService
  ) {}

  ngOnInit() {

    this.modelData = this.dataModel;
    this.modelId = this.dataModelId;

    $('#initialise-page').trigger('click');
    $('#owl-initialise').trigger('click');

  	this.modelForm = this.formBuilder.group({


      status: [true], 
      featured: [false], 
      on_sale: [false], 
      downloadable: [false], 
      shipping_required: [true], 
      reviews_allowed: [true], 

    });

    this.modelForm.controls['sale_price'].clearValidators(); // remove validation
    this.modelForm.controls['date_on_sale_from'].clearValidators(); // remove validation
    this.modelForm.controls['date_on_sale_to'].clearValidators(); // remove validation

    this.prepopulate();

  }

  get f() { return this.modelForm.controls; }

  prepopulate(){

      for (var key in this.modelData) {  // 'field' is a string

        if (this.modelData[key] instanceof Array || this.modelData[key] instanceof Object) {
      
          var innerModelDataObject;

          if (this.modelData[key] instanceof Object) {
            innerModelDataObject = Object.values(this.modelData[key]);

            var innerModelDataObject2 = this.modelData[key];
            console.log(innerModelDataObject2);

            for (const [objectKey, value] of Object.entries(this.modelData[key])) {
              console.log(`${objectKey} ${value}`); // "a 5", "b 7", "c 9"

              for (const objectfield in this.modelForm.controls) {
  
                if(this.modelData[key][objectfield]) {
      
                  this.modelForm.get(objectfield).setValue(this.modelData[key][objectfield]);
                  console.log(objectfield);
                }
      
              }
            }
          }

          //not sure what to do with arrays as yet...

          if (this.modelData[key] instanceof Array) {

            // for (var objectKey in this.modelData[key]) {

            //   alert('value is Array!'+ objectKey);
  
            // }
          }
          
          
        }

        else {

          for (const field in this.modelForm.controls) {
            // console.log(key)
            if(this.modelData[field]) {

              this.modelForm.get(field).setValue(this.modelData[field]);
              //const control = this.modelForm.get(field); // 'control' is a FormControl
              // console.log(field);
    
              //console.log(control);
            }

          }

        }

        

      }
  }
  createItem(): FormGroup {
    return this.formBuilder.group({
      name: '',
      description: '',
      price: '',
      stock: ''
    });
  }

  addItem(): void {
    this.sizes = this.modelForm.get('sizes') as FormArray;
    this.sizes.push(this.createItem());
  }

  onFileChanged(event) {
    //this.files = event.target.files[0];
    //this.modelForm.get('images').setValue(this.files);

    this.filesToUpload = <Array<File>>event.target.files;
  }

  onSubmit() {

    //alert('working magic!')
    $('#buttonText').text('Please Wait...');
    $('#loader').show();

    if (this.modelForm.invalid) {
      console.log('errors are detected');
      this.markFormGroupTouched(this.modelForm);

      $('#buttonText').text('Create Product ');
      $('#loader').hide();

      return;
    }

    console.log('Details being saved in the service: '+JSON.stringify(this.modelForm.value))

    this.createProduct(); // run combine function
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  createProduct() {

    let modelObject1 = new FormData();

    modelObject1.append('modelName', this.modelName);
    modelObject1.append('id', this.modelId);
    modelObject1.append('productSettings-published', this.modelForm.controls['status'].value);
    modelObject1.append('productSettings-completed', this.modelForm.controls['status'].value);
    modelObject1.append('productSettings-status', 'active');
    modelObject1.append('productSettings-featured', this.modelForm.controls['featured'].value);
    modelObject1.append('productSettings-on_sale', this.modelForm.controls['on_sale'].value);
    modelObject1.append('productSettings-downloadable', this.modelForm.controls['downloadable'].value);
    modelObject1.append('productSettings-shipping_required', this.modelForm.controls['shipping_required'].value);
    modelObject1.append('productSettings-reviews_allowed', this.modelForm.controls['reviews_allowed'].value);

    // const files: Array<File> = this.filesToUpload;
    // console.log(files);

    // for(let i =0; i < files.length; i++){
    //     modelObject1.append("uploads[]", files[i]);
    // }


    this.updateModel(modelObject1);

  }

  updateModel (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateModelData(modelObject) 
      .pipe(first())
      .subscribe(
        data => {
 
          this.returnData = data;

          this.modelId = data['result']['id'];
          this.modelData = data['result']['model']['modelData']['formFieldsEntities'];
          console.log('this is the new model return object: '+JSON.stringify(this.returnData));
        },
        error => {
          console.log(error);

          $('#buttonText').text('Create Product ');
          $('#loader').hide();

        },

        () => {

          iziToast.success({
              title: 'Success!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Your product updated successfuly.'
          });

          $('#buttonText').text('Create Product ');
          $('#loader').hide();

          //this.router.navigate(['/sellers/account/product-settings/?id='+id]);
          let details = {
            step : "settings",
            completed : true,
            next: "complete",
            dataModel: this.modelData,
            modelId: this.modelId
          }
          this.formSubmitted.emit(details);
            
        }
      );
  }

  viewGallery()
  {
  	this.router.navigate(['/sellers/account/product-gallery']);
  }

  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed

   
  }


}
